import { objectWithoutProperties as _objectWithoutProperties, extends as _extends, objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useRef } from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
const _excluded = ["uploadFile", "multiple", "renderLook", "inputProps", "sx"];
function IconFileUploader(_ref) {
  let {
      uploadFile,
      multiple,
      renderLook,
      inputProps,
      sx
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const inputRef = useRef(null);
  const handleChange = e => {
    const {
      files
    } = e.target;
    if (files) {
      uploadFile(files);
    }
  };
  return /*#__PURE__*/React__default.createElement(Box, _extends({
    display: "flex",
    alignItems: "center",
    border: "1px solid #D6D6D6",
    borderRadius: "5px",
    padding: "3px 10px",
    width: "fit-content",
    sx: _objectSpread2({
      cursor: 'pointer',
      color: '#383538'
    }, sx),
    onClick: () => inputRef.current.click()
  }, props), /*#__PURE__*/React__default.createElement("input", _extends({
    type: "file",
    hidden: true,
    onChange: handleChange,
    ref: inputRef,
    multiple: multiple,
    accept: "image/*,video/*,application/pdf"
  }, inputProps)), renderLook || /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("i", {
    className: "meta-crm-icon-ic_link font-size-28"
  }), /*#__PURE__*/React__default.createElement(Box, {
    ml: "4px"
  }, "img/pdf/video")));
}
IconFileUploader.propTypes = {
  uploadFile: PropTypes.func,
  renderLook: PropTypes.node,
  multiple: PropTypes.bool,
  inputProps: PropTypes.shape({}),
  sx: PropTypes.shape({})
};
IconFileUploader.defaultProps = {
  uploadFile: () => {},
  renderLook: null,
  multiple: false,
  inputProps: {},
  sx: {}
};
export { IconFileUploader as default };